import React, { ReactNode } from 'react'
import { ConfigProvider, Spin } from 'antd'
import { connect, ConnectedProps } from 'react-redux'

import i18n from 'i18n'
import { Loading3QuartersOutlined } from '@ant-design/icons'

import { antdLocales, type LocaleKey } from './localizationUtils'

export { antdLocales, isAvailable, getAvailableLocale } from './localizationUtils'
export type { LocaleKey } from './localizationUtils'

interface RootState {
  settings: {
    general: {
      locale: LocaleKey
    }
  }
}

const mapStateToProps = (state: RootState) => ({
  locale: state.settings.general?.locale ?? 'ko-KR',
})

const connector = connect(mapStateToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface LocalizationProps extends PropsFromRedux {
  children: ReactNode
}

interface LocalizationState {
  localeInitialized: boolean
}

class Localization extends React.Component<LocalizationProps, LocalizationState> {
  state: LocalizationState = {
    localeInitialized: false,
  }

  componentDidMount(): void {
    const { dispatch, locale } = this.props
    const initLocale = (): void => {
      const isChanged = i18n.language !== locale
      if (isChanged === true) {
        dispatch({
          type: 'settings/SET_LOCALE',
          payload: {
            locale,
          },
        })
      }
      this.setState({ localeInitialized: true })
    }
    if (i18n.isInitialized === true) {
      initLocale()
    } else {
      i18n.on('initialized', () => {
        initLocale()
      })
    }
  }

  render(): React.ReactElement {
    const { localeInitialized } = this.state
    const { children, locale } = this.props

    const currentLocale = antdLocales[locale] ?? antdLocales['ko-KR']
    const antLocale = (currentLocale as any)?.localeAntd || currentLocale?.locale || currentLocale

    const component =
      localeInitialized === true ? (
        <ConfigProvider locale={antLocale}>{children}</ConfigProvider>
      ) : (
        <Spin indicator={<Loading3QuartersOutlined spin />} />
      )

    return component
  }
}

export default connector(Localization)
